import { createContext, useContext, useState } from "react";
import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import { useRouter } from "next/router";
import { useOpinionDetail } from "utils/clientAPIs/debate";
import { OpinionDetailSkeleton } from "components/skeleton/discuss";
import { useRecoilState } from "recoil";
import { debateCleanModeState } from "states/debateState";

interface DebateDetailContextType {
  opinionData: CommentItem;
  commentData: CommentItem[];
  detailMutate: any;
  opinionDetail: any;
}

const DebateDetailContext = createContext<DebateDetailContextType | null>(null);

export const DebateDetailProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { check } = require("korcen");
  const router = useRouter();
  const { opinionId } = router.query;
  const [opinionDetail, isValid, detailMutate] = useOpinionDetail(
    Number(opinionId)
  );
  // const [isCleanMode, setIsCleanMode] = useRecoilState(debateCleanModeState);

  let opinionData = opinionDetail?.find(
    (item: any) => item?.comment_id === Number(opinionId)
  );
  const isCensored = opinionData?.description
    ? check(opinionData?.description)
    : false;
  opinionData = {
    ...opinionData,
    isCensored,
  };
  const commentData = opinionDetail
    ?.filter((item: any) => item?.comment_id !== Number(opinionId))
    ?.map((item: any) => {
      const isCensored = item?.description ? check(item?.description) : false;
      return {
        ...item,
        isCensored,
      };
    });
  if (isValid) return <OpinionDetailSkeleton />;

  return (
    <DebateDetailContext.Provider
      value={{ opinionData, commentData, detailMutate, opinionDetail }}
    >
      {children}
    </DebateDetailContext.Provider>
  );
};

// 커스텀 훅으로 사용
export const useDebateDetailContext = () => {
  try {
    const context = useContext(DebateDetailContext);
    if (!context)
      throw new Error(
        "useDebateDetailContext must be used within DebateDetailProvider"
      );
    return context;
  } catch (error) {
    return null;
  }
};
